import Header from '../components/header';
import '../css/index.scss';
import '../css/adam.scss';

import { initDemo } from '../js/adam/demo';
import { initScenes } from '../js/adam/scenes';
import { revealOnScroll } from '../js/adam/reveal';
import { initSystemNav } from '../js/adam/system-nav';

new Header();

initDemo();
initScenes();
revealOnScroll();
initSystemNav();
